// Define the structure of the response data
interface Allocation {
  soldOut: boolean;
  name: string;
}

interface EventInstance {
  id: string;
  name: string;
  eventName: string;
  date: string;
  soldOut: boolean;
  saleStatus: string;
  purchaseUrl: string;
  allocations: Allocation[];
}

interface Event {
  name: string;
  type: string;
  purchaseUrl: string;
  instances: EventInstance[];
}

// Fetch ticket data function
const fetchTicketData = async (getBirthdays: boolean = false): Promise<Event[]> => {
  try {
    const response = await fetch('/.netlify/functions/getTicketing', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ getBirthdays }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: Event[] = await response.json();

    return data;
  } catch (error) {
    console.error('Failed to fetch data:', error);
    return [];
  }
};

export default fetchTicketData;
